import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchCompanies, updateCompany } from '../actions/companies';
import { updateUserDataRequest } from '../actions/auth';
import DocumentTitle from '../components/DocumentTitle';
import Header from '../components/auth/Header';
import CompanyDeleteModal from '../components/companies/CompanyDeleteModal';
import SearchBox from '../components/partials/SearchBox';
import __ from '../helpers/translation';

const propTypes = {
  fetchCompanies: PropTypes.func.isRequired,
  updateCompany: PropTypes.func.isRequired,
  updateUserDataRequest: PropTypes.func.isRequired
};

const REQUEST_STATUS_OPEN = 0;
const REQUEST_STATUS_CONNECTED = 1;
const REQUEST_STATUS_DISCONNECTED = 3;

class Companies extends Component {
  constructor (props) {
    super(props);
    this.state = {
      'companies': null,
      'searchText': '',
      'filterCompanies': null,
      'currentCompany': null
    };

    this.companyActions = this.companyActions.bind(this);
  }

  loadCompanies() {
    this.props.fetchCompanies()
        .then(data => this.setState({ 
            companies: data.companies
        }))
        .catch(error => {
            return Promise.reject(error)
        });
  }

  componentDidMount () {
    document.body.classList.add('bg-grey-image');
    this.loadCompanies();
  }

  componentWillUnmount () {
    document.body.classList.remove(... document.body.classList);
  }

  handleChange(e, company) {
    let newStatus = e.target.checked ? REQUEST_STATUS_CONNECTED : REQUEST_STATUS_DISCONNECTED;
    let companyIndex = this.state.companies.findIndex(item => item.id === company.id);
    //console.log(companyIndex);

    this.setState(previousState => {
        let companies = [...previousState.companies];

        companies[companyIndex] = {
          ...companies[companyIndex],
          status: newStatus
        };

        return { companies };
    });

    this.props.updateCompany({...company, status: newStatus})
      .then(() => {
        this.props.updateUserDataRequest();
      })
      .catch(error => {
          this.loadCompanies();
          return Promise.reject(error)
      });
  }

  companyActions(company){
    this.setState({
      currentCompany: company
    }, () => {
      window.$('#companyActions').modal('show');
    });
  }

  deleteCompany(){
    window.$('#companyActions').modal('hide');
    window.$('#deleteCompany').modal('show');
  }

  company(company){
    let isChecked = company.status == REQUEST_STATUS_CONNECTED;
    return (
      <div key={company.id} className="d-block">
        <div className="toggle">
            <input type="checkbox" className="check" defaultChecked={isChecked} onChange={e => this.handleChange(e, company)} />
            <b className="b switch"></b>
            <b className="b track"></b>
        </div>
        <div className="d-inline-block ml-3">
            <strong>{ company.status == REQUEST_STATUS_OPEN && <span><span className="dot orange"></span>&nbsp;</span>}{ company.name }</strong>
            <p className="text-muted">{ __('app.companies.reports') } <span>{ company.reports_count }</span></p>
        </div>
        <i className="far fa-ellipsis-h text-muted float-right" onClick={(e) => this.companyActions(company) }></i>
      </div>
    )
  }

  filteredCompanies() {

    let rows = [];
    
    for(let i = 0; i < this.state.filterCompanies.length; i++){
      rows.push(
        this.company(this.state.filterCompanies[i])
      );
    }
        
    return rows.length ? rows : __('app.general.search_no_results');
  }

  companies() {
    let rows = [];
    
    for(let i = 0; i < this.state.companies.length; i++){
      rows.push(
        this.company(this.state.companies[i])
      );
    }
        
    return rows.length ? rows : __('app.companies.no_results');
  }

  searchCompanies(searchText){
    
    if(!searchText){
      this.setState({
        'filterCompanies' : null,
        'searchText': searchText
      });
      return;  
    }

    let companies = this.state.companies;
    let filteredCompanies = companies.filter(company => company.name.toLowerCase().includes(searchText.toLowerCase()))
    this.setState({
      'filterCompanies' : filteredCompanies,
      'searchText': searchText
    });
  }

  render () {
    return (
      <DocumentTitle title={`${__('app.navigation.companies')} - ${window.App.name}`}>
        <Fragment>
          <Header title={__('app.navigation.companies')} />
          <div className="container mt-5">
              <div className="row mt-5">
                  <div className="col-md-8 offset-md-2 col-12">
                      <SearchBox 
                        callback={(text) => this.searchCompanies(text)}
                        disabled={!this.state.companies || this.state.companies.length < 3}
                        searchText={this.state.searchText}
                      />
                      <div className="md-box">
                          { 
                            this.state.companies &&
                            ( this.state.searchText ? this.filteredCompanies() :  this.companies() )
                          }
                      </div>
                  </div>
              </div>
          </div>
          <div className="modal bottom modal-menu" id="companyActions" tabIndex="-1" role="dialog" aria-labelledby="companyActions" aria-hidden="true">
              <div className="modal-dialog" role="document">
                  <div className="modal-content align-items-center justify-content-center">
                      <div className="container">
                          <div className="row mb-5">
                              <div className="col-md-6 col-12 offset-md-3 d-flex flex-column line-height-40">
                                  <a className="d-flex flex-row text-dark font-size-18 cur-p" 
                                       onClick={(e) => { this.deleteCompany() } } >
                                       <div className="icon-container">
                                         <i className="far fa-trash"></i>
                                       </div>
                                       <p>{ __('app.general.delete') }</p>
                                  </a>
                              </div>
                          </div>
                      </div>
                      <a data-dismiss="modal" className="textred text-uppercase font-size-18 cur-p">{ __('app.general.close_menu') }</a>
                  </div>
              </div>
          </div>
           <CompanyDeleteModal company={this.state.currentCompany} 
                onDeleted={() => { 
                  this.setState({
                    currentCompany: null
                  });
                  this.loadCompanies();
              } } />
        </Fragment>
      </DocumentTitle>
    );
  }
}

Companies.propTypes = propTypes;

const mapDispatchToProps = {
  fetchCompanies,
  updateCompany,
  updateUserDataRequest
};

export default connect(null, mapDispatchToProps)(withRouter(Companies));